import { toSignupLogin } from './toSignupLogin'

export const showCreateAccountForm = {
    state: {
        showCreateAccountComp: ''
    },
    actions: {
        showCreateAccountForm({ commit }, createAccountForm) {
            commit('SHOW_CREATE_ACCOUNT_FORM', createAccountForm)
        }
    },
    mutations: {
        SHOW_CREATE_ACCOUNT_FORM(state, showCreateAccountComp) {
            state.showCreateAccountComp = showCreateAccountComp
            toSignupLogin.state.showSignupLogin = false
        }
    },
    getters: {
        showCreateAccountForm(state) {
            return state.showCreateAccountComp
        }
    }
}
